import { Button, Form, Image, Input, message, Modal, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React, { useEffect, useState } from 'react';
import { useForm } from 'antd/lib/form/Form';
import MediaManager from '../Media/MediaManager';
import { MAIN_URL } from '../../Constants';
import emptyimg from './../../assets/images/emptyimage.jpg';
import axios from 'axios';

function CompanyForm({ lang, company }) {
    // `company`, `logo`, `address`, `phone`, `email`, `work_time`, `telegram`, `facebook`, `instagram`, `lang`, `meta_keys`, `meta_desc`
    let [open, setOpen] = useState(false);
    let [logo, setLogo] = useState('');
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue(company);
        setLogo(company?.logo ?? '');
    }, [company]);
    return (
        <>
            <Modal width={'80%'} open={open} footer={null} onCancel={() => setOpen(false)}>
                <MediaManager onSelect={(e) => { setOpen(false); setLogo(e) }} />
            </Modal>
            <Form layout="vertical" labelAlign="left" form={form}
                onFinish={(values) => {
                    values.logo = logo;
                    axios.put(`/company/${company.id}`, values).then(res => {
                        message.success('Muvaffaqiyatli yangilandi');
                    });
                }}

            >
                <Form.Item hidden label="Id" name="id">
                    <Input />
                </Form.Item>
                <Form.Item hidden label="lang" name="lang">
                    <Input />
                </Form.Item>
                <Form.Item label="Nomi" name="company">
                    <Input />
                </Form.Item>
                <Form.Item label="Logotip" name="logo">
                    <Button onClick={() => setOpen(true)}>Fayl yuklash</Button>
                    <Image src={logo ? MAIN_URL + '/' + logo : emptyimg} width={100} height={100} style={{ objectFit: 'cover' }} />
                </Form.Item>
                <Form.Item label="Manzil" name="address">
                    <Input />
                </Form.Item>
                <Form.Item label="Telefon" name="phone">
                    <Input />
                </Form.Item>
                <Form.Item label="Email" name="email">
                    <Input />
                </Form.Item>
                <Form.Item label="Ish vaqti" name="work_time">
                    <Input />
                </Form.Item>
                <Form.Item label="Telegram" name="telegram">
                    <Input />
                </Form.Item>
                <Form.Item label="Facebook" name="facebook">
                    <Input />
                </Form.Item>
                <Form.Item label="Instagram" name="instagram">
                    <Input />
                </Form.Item>
                <Form.Item label="Meta kalitlar" name="meta_keys">
                    <Input />
                </Form.Item>
                <Form.Item label="Meta tavsif" name="meta_desc">
                    <TextArea />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Saqlash</Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default CompanyForm;